//import Boton from "components/boton/Boton"
import { useNavigate } from 'react-router-dom'

import "components/generales/Styles.css"
import "./Styles.css"

const Etiqueta = ({ etiqueta, handleEliminar, }) => {
  const navigate = useNavigate()
  const { descripcion, clasificacion, id } = etiqueta

  return (
    <div className="contenedor_etiqueta">
      <section className="color">
        {etiqueta.color === "#AD1457" &&
          <div className="forma jazzberry-jam"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#C62828" &&
          <div className="forma fire-engine-red"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#D84315" &&
          <div className="forma vermilion"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#EF6C00" &&
          <div className="forma spanish-orange"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#F9A825" &&
          <div className="forma bright-yellow"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#2E7D32" &&
          <div className="forma japanese-laurel"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#558B2F" &&
          <div className="forma maximum-green"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#0D47A1" &&
          <div className="forma yale-blue"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#0277BD" &&
          <div className="forma ocean-boat-blue"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#00ACC1" &&
          <div className="forma tiffany-blue"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#4527A0" &&
          <div className="forma blue-pigment"><h4>{descripcion}</h4></div>}
        {etiqueta.color === "#6A1B9A" &&
          <div className="forma chinese-purple"><h4>{descripcion}</h4></div>}
      </section>
      <section className='tarjeta'>
        <div className='info'>
          {etiqueta.tipo === "gasto" && <p>Tipo: Gasto</p>}
          {etiqueta.tipo === "ingreso" && <p>Tipo: Ingreso</p>}
          <p>Clasificación: {clasificacion}</p>
          <div className='botones'>
            <button
              type="button"
              onClick={() => navigate(`/etiquetas/editar/${id}`)}
            >Editar</button>
            <button
              type="button"
              onClick={() => handleEliminar(id)}
            >Eliminar</button>
          </div>
        </div>
      </section>
    </div>
  )

}

export default Etiqueta